module.exports = __webpack_public_path__ + "img/galaxy-shooter-2.df83fc05.png";